<template>
    <div class="mt-3.5">
        <HelpchatItem
            v-for="(helpchat) in helpchatList"
            :key="helpchat.id"
            :helpchat="helpchat"
        >
        </HelpchatItem>
    </div>
</template>
<script>

import HelpchatItem from "./HelpchatItem.vue";
import BzbsHelpchat from "@/core/Helpchat/BzbsHelpchat.js";
//helper
import Account from "@/helper/AccountHelper.js";

export default ({
    name: 'helpchat',
    components: {
        HelpchatItem,
    },
    props: {
        initListConfig: { type: Object, required: true },
        modalController: { type: Object },
    },
    data: function() {
        return {
            helpchatList: [],

            isLoading: false,
            isLoaded: false,
            isHaveItem: false,
        }
    },
    created: function () {
        this.listConfig = this.initListConfig;
    },
    mounted: function() {

        console.log("helpchatList");
        console.log("helpchatList",this.helpchatList);
        this.getHelpchatList();
    },
    methods: {

        getHelpchatList: function () {
            let user = Account.getCacheUser();
            if (!user) {
                return;
            }
            this.strLastRowKey = "";
            if (this.helpchatList.length > 0) {
                let item = this.helpchatList[this.helpchatList.length - 1];
                this.strLastRowKey = item.rowKey;
            }

            return new Promise((resolve) => {
                this.isLoading = true;
                BzbsHelpchat.apiGetHelpchat(user.userId, this.strLastRowKey).subscribe({
                    next: (datas) => {
                        console.log(datas);
                        this.listConfig.intSkip += this.listConfig.defaultTopAmount;
                        console.log("listConfig", this.listConfig);

                        console.log(this.listConfig.defaultTopAmount);
                        if (datas && datas.length < this.listConfig.defaultTopAmount) {
                            this.listConfig.isSeeMoreEnable = false;
                        }

                        if (this.listConfig.intSkip == this.listConfig.defaultTopAmount) {
                            this.helpchatList = [];
                        }

                        for (let data of datas) {
                            //TODO: Add GA Tracking.
                            this.helpchatList.push(data);
                        }

                        this.isLoading = false;
                        this.isLoaded = true;
                        this.isHaveItem = this.helpchatList.length > 0
                            ? true
                            : false;
                        console.log("this.helpchatList",this.helpchatList)
                        resolve(true);
                    },
                    error: (err) => {
                        this.isLoading = false;
                        this.isLoaded = true;
                        this.isHaveItem = false;
                        console.log(err);
                        resolve(false);
                    }
                });
            });
        },
        reinitList: function() {
            this.strLastRowKey = "";
            this.helpchatList = [];
            this.getHelpchatList();
        },

        loadMore: async function() {
            console.log('load more list', this.listConfig.isSeeMoreEnable);
            if (!this.listConfig.isSeeMoreEnable || this.isLoading) {
                return;
            }

            this.modalController.loadingModal.show();
            await this.getHelpchatList();
            this.modalController.loadingModal.hide();
        },
    }
})
</script>
